<template>
  <div class="">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-12 col-12" v-if="userLogin === false">
        <img class="" style="height: 95%" src="../../../assets/images/Newlandindpage/New1.png" alt="" />
      </div>
      <div class="col-lg-6 col-md-12 col-12 left-fade" v-if="userLogin === true">
        <img class="" style="height: 95%" src="../../../assets/images/Newlandindpage/Group_28491.png" alt="" />
      </div>
      <div class="col-lg-6 col-md-12">
        <div v-for="(service, index) in serviceList" :key="index">
          <div :class="` ${cardStyle} ${checkTextAlign}`" data-aos="fade-up" data-aos-delay="70" class="">
            <div class="inner">
              <div class="content">
                <h4 class="title LexenExtraLight pt--40" style="font-size: 20px; width: 80%">
                  {{ service.title }}
                </h4>
                <p class="description LexenExtraLight" v-text="service.description" />
                <div class="hrr"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServiceTwo',
  props: {
    cardStyle: {
      type: String
    },
    textAlign: {
      type: String,
      default: 'left'
    }
  },
  data() {
    return {}
  },
  computed: {
    serviceList() {
      return this.$t('Servicepros.items')
    },
    checkTextAlign() {
      if (this.textAlign === 'left') return 'text-start'
      else if (this.textAlign === 'center') return 'text-center'
      else if (this.textAlign === 'end') return 'text-end'
      else return ''
    },
    userLogin() {
      return this.$store.state.userLogin
    }
  }
}
</script>

<style>
.shadowed-border2::after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 0.9px solid rgb(51, 14, 69);
  /* สีขอบสำหรับเงาขาว */
  border-radius: 6px;
  /* ความโค้งขอบสำหรับเงาขาว */
  box-shadow: 0px 0px 10px 5px rgba(45, 45, 45, 0.7);
}

.hrr {
  top: 864px;
  left: 664px;
  width: 550px;
  height: 0px;
  /* UI Properties */
  border: 1px solid var(--unnamed-color-707070);
  border: 1px solid #707070;
  opacity: 0.51;
  margin-top: 5%;
}

@media only screen and (max-width: 991px) {
  .pt--140 {
    padding-top: 20px !important;
  }
}

.left-fade {
  -webkit-mask-image: linear-gradient(to left, transparent 0%, black 20%, black 60%, transparent 94%);
  mask-image: linear-gradient(to left, transparent 0%, black 20%, black 60%, transparent 99%);
}
</style>
